var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepValid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create-a-project",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DG-TieOut-|-Create-a-Project-|-First-Section-Legal-Hold-Enabled",
    transform: "translate(-62.000000, -206.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-Tick",
    transform: "translate(62.000000, 206.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "checkmark",
    strokeWidth: 1,
    fillRule: "evenodd",
    fill: "#009A44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0314286,0.105490683 C5.00397516,0.105490683 0.117515528,4.99195031 0.117515528,11.019677 C0.117515528,17.0471304 5.00397516,21.9337267 11.0314286,21.9337267 C17.058882,21.9337267 21.9453416,17.0471304 21.9453416,11.019677 C21.9453416,4.99195031 17.058882,0.105490683 11.0314286,0.105490683 Z M11.0314286,1.01500621 C16.5478261,1.01500621 21.0352795,5.50300621 21.0352795,11.019677 C21.0352795,16.5359379 16.5478261,21.0240745 11.0314286,21.0240745 C5.51503106,21.0240745 1.02621118,16.5359379 1.02621118,11.019677 C1.02621118,5.50300621 5.51503106,1.01500621 11.0314286,1.01500621 Z M17.2638509,6.60532919 C17.0862112,6.4275528 16.7992547,6.4275528 16.6216149,6.60532919 L7.84757764,15.3786832 L4.98621118,12.5171801 C4.80857143,12.3394037 4.52024845,12.3394037 4.3426087,12.5171801 C4.16496894,12.6946832 4.16496894,12.9824596 4.3426087,13.160236 L7.52645963,16.3434037 C7.6152795,16.432087 7.73142857,16.4764969 7.84757764,16.4764969 C7.96372671,16.4764969 8.08124224,16.432087 8.17006211,16.3434037 L17.2638509,7.24824845 C17.4414907,7.0706087 17.4414907,6.78296894 17.2638509,6.60532919 Z",
    id: "icon_success"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepValid);
export default __webpack_public_path__ + "static/media/stepValid.4a828118c0e430f8e86b97672a2a4f63.svg";
export { ForwardRef as ReactComponent };